import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=0cf567a1&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "notfound.vue"
export default component.exports